import {
  GET_YUSA_OVERNIGHT_CAMP_REVENUE_DETAILS,
  GET_YUSA_OVERNIGHT_CAMP_EXPENSES_DETAILS,
  POST_YUSA_OVERNIGHT_CAMP_REVENUE_DETAILS,
  POST_YUSA_OVERNIGHT_CAMP_EXPENSES_DETAILS
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

// eslint-disable-next-line import/prefer-default-export
export const getOvernightCampDataRevenueList =
  (branchNumber, reportBatchId, year) => (dispatch, getState) =>
    asyncRequest({
      url: GET_YUSA_OVERNIGHT_CAMP_REVENUE_DETAILS(
        branchNumber,
        reportBatchId,
        year
      ),
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_REVENUE_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_REVENUE_FAILURE,
        payload: error
      }),
      dispatch
    });

export const postOvernightCampDataRevenue =
  payloadBody => (dispatch, getState) =>
    asyncRequest({
      url: POST_YUSA_OVERNIGHT_CAMP_REVENUE_DETAILS(),
      method: 'POST',
      data: payloadBody,
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_REVENUE_LIST_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_REVENUE_LIST_FAILURE,
        payload: error
      }),
      dispatch
    });

export const getOvernightCampDataExpensesList =
  (branchNumber, reportBatchId, year) => (dispatch, getState) =>
    asyncRequest({
      url: GET_YUSA_OVERNIGHT_CAMP_EXPENSES_DETAILS(
        branchNumber,
        reportBatchId,
        year
      ),
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_EXPENSES_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_EXPENSES_FAILURE,
        payload: error
      }),
      dispatch
    });

export const postOvernightCampDataExpenses =
  payloadBody => (dispatch, getState) =>
    asyncRequest({
      url: POST_YUSA_OVERNIGHT_CAMP_EXPENSES_DETAILS(),
      method: 'POST',
      data: payloadBody,
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_EXPENSES_LIST_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_EXPENSES_LIST_FAILURE,
        payload: error
      }),
      dispatch
    });

export const resetReduxState = key => ({
  type: 'RESET_KEY',
  payload: { key }
});
